import { StringHelpers } from '@headless-workspace/utils';
import { DataLayerYesNo } from './DataLayerEvent';

const addEventListeners = (
    selector: string,
    handler: (element: Element) => EventListener,
    refs: [Element, EventListener][],
) => {
    if (typeof document !== 'undefined') {
        const elements = document.querySelectorAll(selector);
        if (elements.length) {
            Array.from(elements).forEach((element) => {
                const eventHandler = handler(element);
                if (eventHandler) {
                    element.addEventListener('click', eventHandler);
                    refs.push([element, eventHandler]);
                }
            });
        }
    }
};

const addImpressionObserver = (
    selector: string,
    callback: (element: Element) => void,
    refs: IntersectionObserver[],
    options?: IntersectionObserverInit,
) => {
    if (typeof document === 'undefined') return;

    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => {
        const observer = createObserver(element, callback, options);
        refs.push(observer);
    });
};

const mapBooleanToYesNo = (value?: boolean): DataLayerYesNo => {
    return value ? DataLayerYesNo.Yes : DataLayerYesNo.No;
};

const mapStringToYesNo = (value?: string): DataLayerYesNo => {
    return value && StringHelpers.isNotEmpty(value) ? DataLayerYesNo.Yes : DataLayerYesNo.No;
};

const extractSpaceId = (carouselId: string): string => {
    const parts = carouselId.split('-');
    return parts.length > 0 ? parts[parts.length - 1] : '';
};

const createObserver = (
    targetElement: Element,
    callback: (element: Element) => void,
    options: IntersectionObserverInit = {},
): IntersectionObserver => {
    const observerOptions = {
        root: options.root || null,
        rootMargin: options.rootMargin || '0px',
        threshold: options.threshold || 0.5,
    };

    const observerCallback = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                callback(entry.target);
                observer.unobserve(entry.target);
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    observer.observe(targetElement);
    return observer;
};

export const DataLayerUtils = {
    addEventListeners,
    mapBooleanToYesNo,
    mapStringToYesNo,
    addImpressionObserver,
    extractSpaceId,
};
